import { toast } from "@volca/ui/lib/toast";
import { useStartQuickbooksOauth } from "./quickbooks-query";

/**
 * Starts the QuickBooks OAuth flow and sends the browser to Intuit. Connect and
 * reconnect share it: the API restores a returning company's settings itself.
 *
 * @returns `connect` to call from a button, and `isPending`, which stays true
 *   after success while the browser leaves for Intuit.
 */
export const useConnectQuickbooks = (businessId?: string | null) => {
  const { mutateAsync, isPending, isSuccess } =
    useStartQuickbooksOauth(businessId);

  const connect = async () => {
    if (!businessId) {
      toast.error("Business not found.", {
        description: "Refresh the page and try again.",
      });
      return;
    }

    try {
      const data = await mutateAsync();
      window.location.href = data.authorize_url;
    } catch (error) {
      toast.error("Unable to start QuickBooks connection.", {
        description:
          error instanceof Error ? error.message : "Please try again.",
      });
    }
  };

  return { connect, isPending: isPending || isSuccess };
};
